'use strict';

var _app = require('./app');

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

try {
  angular.module('views');
} catch (e) {
  angular.module('views', []);
}
angular.element(document).ready(function () {
  angular.bootstrap(document, [_app2.default]);

  // side widget
  var slideout = $('#slideout');
  var slideoutInner = $('#slideout_inner');
  var scrollZone = slideout.find('.nano');

  var toggle = function toggle() {
    slideout.toggleClass('active-out');
    slideoutInner.toggleClass('active-inner');

    scrollZone.nanoScroller({ destroy: true });
    scrollZone.nanoScroller({
      nanoClass: 'nano',
      contentClass: 'nano-content'
    });
  };
  slideout.find('.toggler').click(toggle);
});


//////////////////
// WEBPACK FOOTER
// ./app/init.js
// module id = 0
// module chunks = 0